export type ProntuarioClinicalHistoryRecord = {
	instrumentosUtilizados?: string;
	impressaoClinica?: string;
	cid10Hipoteses?: string;
	diagnosticoDiferencial?: string;
	bai?: string;
	bdi?: string;
};

export type ProntuarioClinicalHistoryFieldKey =
	keyof ProntuarioClinicalHistoryRecord;

export const PRONTUARIO_CLINICAL_HISTORY_FIELDS: ReadonlyArray<{
	key: ProntuarioClinicalHistoryFieldKey;
	label: string;
	fullWidth?: boolean;
}> = [
	{
		key: 'instrumentosUtilizados',
		label: 'Instrumentos Utilizados',
		fullWidth: true,
	},
	{ key: 'impressaoClinica', label: 'Impressão Clínica', fullWidth: true },
	{ key: 'cid10Hipoteses', label: 'CID-10 (Hipótese)', fullWidth: true },
	{
		key: 'diagnosticoDiferencial',
		label: 'Diagnóstico Diferencial',
		fullWidth: true,
	},
	{ key: 'bai', label: 'BAI (ansiedade)' },
	{ key: 'bdi', label: 'BDI (depressão)' },
];

export const getProntuarioClinicalHistoryVisibleFields = (
	record: ProntuarioClinicalHistoryRecord,
) =>
	PRONTUARIO_CLINICAL_HISTORY_FIELDS.filter(({ key }) => {
		const value = record[key];
		return typeof value === 'string' && value.trim().length > 0;
	});
